module.exports = __webpack_public_path__ + "static/media/Master Deed and By-Laws-OCR.d7e7afcb.pdf";